import React from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import { useDirtyWarningContext, DirtyWarningInputProps } from '../DirtyWarning';

export interface SelectProps extends DirtyWarningInputProps {    
    name: string;

    key?: string;
    label?: string;       
    value?: any | null;
    disabled?: boolean;

    options?: any[];
    getKey?: (option: any) => string | number;
    getName?: (option: any) => string;

    onChange: (e: React.FormEvent<FormControl>) => void;
    validationState?: () => 'success' | 'warning' | 'error' | null;
}

const SelectComponentInternal: React.FC<SelectProps> = (props) => {   
   const { disableDirtyTracking = false, onChange, getKey, getName, options, validationState, ...selectProps } = props;
   const validationStateResult = validationState ? validationState() : null;
   const context = useDirtyWarningContext();    

   const handleChange = (e: React.FormEvent<FormControl>) => {
      if (onChange) {
         onChange(e);
      }

      if (!disableDirtyTracking) {
         context.setDirty(true);
      }
   }

   let childContent: any = props.children;

   if (props.options != null) {
      let getKeyFn = props.getKey || function(option) { return option.id };
      let getNameFn = props.getName || function(option) { return option.name };
      childContent = props.options.map(option => {
         const id = getKeyFn(option);
         const name = getNameFn(option);
         return <option key={id} value={id}>{name}</option>
      })
   }   

   if (!props.label) return (
      <FormControl componentClass="select" onChange={handleChange} {...selectProps}>
         {childContent}
      </FormControl>
   );

   return (
      <FormGroup controlId={props.key} validationState={validationStateResult}>
         <ControlLabel>{props.label}</ControlLabel>
         <FormControl componentClass="select" onChange={handleChange} {...selectProps}>
            {childContent}
         </FormControl>
      </FormGroup>
   );
}

(SelectComponentInternal as any).displayName = 'Select';

export const Select: React.FC<SelectProps> = React.memo(SelectComponentInternal) as any;